import { useCurrentUser } from "@qualio/ui-components";

import { hasPermission } from "../domain/hasPermission";
import { UserPermissions } from "../domain/permissions";

export type HasPermissionType = Record<string, boolean>;

const useHasPermission = (
  permissions: readonly UserPermissions[],
): HasPermissionType => {
  const { userGroups } = useCurrentUser();

  return permissions.reduce(
    (table: HasPermissionType, permission): HasPermissionType => {
      table[permission] = hasPermission(userGroups, permission);
      return table;
    },
    {},
  );
};

export default useHasPermission;
